import PullToRefresh from "react-simple-pull-to-refresh";
import { Row, Col, Card, Tag, Typography, Space, Avatar, Button } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "../../../node_modules/react-router-dom/dist/index";
import { useAuth } from "../../AuthContext";
import GETListarAuditoriasDisponibles from "../../helpers/auditoria/GETListarAuditoriasDisponibles";
import HeaderEstandar from "../../components/layout/headers/HeaderEstandar";
import AppLayout from "../../components/layout/AppLayout";
import Loader from "../../components/loader/Loader";
import { estadoConfig } from "../../utils/getEstadoProp";
import { getCardStyle } from "../../utils/getCardStyle";
import { formatFecha } from "../../utils/formatFecha";
import POSTNuevaAuditoria from "../../helpers/auditoria/POSTNuevaAuditoria";
import ActionResultModal from "../../components/actionResultModal.js/ActionResultModal";

const { Text } = Typography;

const MisAuditorias = ({ darkMode, setDarkMode }) => {
  const navigate = useNavigate();
  const { loggedUser } = useAuth();
  const [auditorias, setAuditorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({
    open: false,
    message: "",
    type: "success",
    orden: null,
    modalType: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GETListarAuditoriasDisponibles();
        if (Array.isArray(response?.data)) {
          setAuditorias(response.data);
        } else {
          console.warn("La respuesta no es un array válido:", response);
          setAuditorias([]);
        }
      } catch (error) {
        console.error("Error al cargar auditorías:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [loggedUser]);

  const headerComponent = (
    <HeaderEstandar data={{ headerTitle: "Mis Auditorias" }} />
  );

  const handleNuevaAudStock = async () => {
    try {
      const response = await POSTNuevaAuditoria();
      if (response?.data?.codres === 0) {
        setModal({
          open: true,
          message: response.data?.descri || "Auditoria creada exitosamente.",
          type: "success",
          orden: response?.data?.codope,
          modalType: "auditoria",
        });
      } else {
        setModal({
          open: true,
          message: response?.data?.descri || "No se pudo crear la auditoria.",
          type: "error",
          modalType: null,
        });
      }
    } catch (error) {
      console.error("Error al crear la auditoria:", error);
      setModal({
        open: true,
        message: "Ocurrió un error inesperado.",
        type: "error",
        modalType: null,
      });
    }
  };

  const closeModal = () =>
    setModal({
      open: false,
      message: "",
      type: "success",
      orden: null,
      modalType: null,
    });

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <PullToRefresh
        onRefresh={async () => {
          setLoading(true);
          try {
            const response = await GETListarAuditoriasDisponibles();
            if (Array.isArray(response?.data)) {
              setAuditorias(response.data);
            } else {
              console.warn("La respuesta no es un array válido:", response);
              setAuditorias([]);
            }
          } catch (error) {
            console.error("Error al cargar auditorías:", error);
          } finally {
            setLoading(false);
          }
        }}
        maxPullDownDistance={80}
        refreshingContent={null}
        pullingContent={null}
      >
        <div
          style={{
            height: "100%",
            padding: "8px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {loading && <Loader />}

          <Row gutter={[8, 8]} justify="start" align="stretch">
            <Col span={24}>
              <Button
                type="primary"
                block
                size="large"
                style={{
                  backgroundColor: "#34A853",
                  borderColor: "#34A853",
                }}
                onClick={() => handleNuevaAudStock()}
              >
                Nueva auditoria de stock
              </Button>
            </Col>

            {auditorias.length === 0 && !loading ? (
              <Col span={24}>
                <Card
                  style={{
                    textAlign: "center",
                    backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "32px",
                  }}
                >
                  <Text type="secondary" style={{ fontSize: "19px" }}>
                    No hay auditorías disponibles.
                  </Text>
                </Card>
              </Col>
            ) : (
              auditorias.map((auditoria, index) => {
                const estado = estadoConfig[auditoria.estado];

                return (
                  <Col span={24} key={index} style={{ display: "flex" }}>
                    <Card
                      onClick={() => {
                        if (auditoria.idauds) {
                          navigate(`/auditorias/${auditoria.idauds}`);
                        }
                      }}
                      hoverable
                      styles={{ body: { padding: 16 } }}
                      style={{
                        ...getCardStyle(darkMode),
                        height: "100%",
                        flex: 1,
                      }}
                    >
                      <Row align="middle" justify="space-between">
                        <Space align="start">
                          <Avatar
                            src="/assets/audit-icon.png"
                            size={60}
                            style={{ backgroundColor: "#fec606" }}
                          />
                          <div>
                            <Text
                              strong
                              style={{
                                fontSize: "21px",
                                color: darkMode ? "#fff" : "#000",
                              }}
                            >
                              {auditoria.numero}
                            </Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: "15px" }}>
                              {formatFecha(auditoria.fecha)}
                            </Text>
                          </div>
                        </Space>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 120,
                            marginTop: 8,
                          }}
                        >
                          <Tag
                            color={estado?.color}
                            icon={estado?.icon}
                            style={{
                              fontSize: 17,
                              width: 120,
                              textAlign: "center",
                            }}
                          >
                            {estado?.text}
                          </Tag>
                        </div>
                      </Row>
                    </Card>
                  </Col>
                );
              })
            )}
          </Row>
        </div>
      </PullToRefresh>
      <ActionResultModal
        open={modal.open}
        onClose={closeModal}
        type={modal.type}
        message={modal.message}
        orden={modal.orden}
        modalType={modal.modalType}
      />
    </AppLayout>
  );
};

export default MisAuditorias;
